import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class IdDto {
  @ApiProperty({ type: 'string', format: 'uuid' })
  id!: string;
}

export class TimestampsDto {
  @ApiProperty({ type: 'string', format: 'date-time' })
  createdAt!: string | Date;

  @ApiProperty({ type: 'string', format: 'date-time' })
  updatedAt!: string | Date;
}

export class AuthorEstablishmentDto {
  @ApiProperty()
  authorUserId!: string;

  @ApiPropertyOptional({ nullable: true })
  establishmentId!: string | null;
}

export class BaseEntityResponseDto extends IdDto implements TimestampsDto {
  @ApiProperty({ type: 'string', format: 'date-time' })
  createdAt!: string | Date;

  @ApiProperty({ type: 'string', format: 'date-time' })
  updatedAt!: string | Date;
}
